<template>
  <AppMainFormCard
    :isLoading="isLoading"
    :tituloTela="tituloTela"
    :canDelete="isEditing"
    @delete="beforeDeleteRegistro"
    @add="novoRegistro"
    :isSearch="true"
    @search="goSearch"
  >
    <v-form v-model="isFormValid" ref="form">
      <v-layout row justify-center>
        <v-flex class="item" xs12 md11 ma-5>
          <h3><b>Dados do Estabelecimento</b></h3>
        </v-flex>
      </v-layout>
      <v-layout row justify-center="">
        <v-flex class="item" xs11 md4 lg4>
          <v-text-field
            :rules="[campoObrigatorio]"
            v-model.trim="registro.nrCodigoOficial"
            return-masked-value
            v-mask="maskCodigoOficial"
            label="Código Oficial"
            outlined
            clearable
            @blur="completaCodigoOficialDozeDigitos"
          >
          </v-text-field>
        </v-flex>
        <v-flex class="item" xs11 md7 lg7>
          <v-text-field
            :rules="[campoObrigatorio]"
            v-model.trim="registro.nmEstabelecimento"
            label="Nome"
            outlined
            dclearable
          >
          </v-text-field>
        </v-flex>
      </v-layout>
      <v-layout row wrap justify-center="">
        <v-flex class="item" xs11 md4 lg4>
          <v-autocomplete
            :rules="[campoSelectObrigatorio]"
            v-model="registro.cdUf"
            :items="ufs"
            color="primary"
            item-text="sgUf"
            item-value="idUf"
            label="Selecione a UF"
            no-data-text="Nenhum registro"
            outlined
            clearable
          >
          </v-autocomplete>
        </v-flex>
        <v-flex class="item" xs11 md7 lg7>
          <v-autocomplete
            :rules="[campoSelectObrigatorio]"
            v-model="registro.cdMunicipio"
            :items="filteredCities"
            color="primary"
            item-text="nmMunicipio"
            item-value="idMunicipio"
            label="Selecione o Município"
            no-data-text="Nenhum registro"
            outlined
            clearable
          >
          </v-autocomplete>
        </v-flex>
      </v-layout>
      <v-layout row justify-center="">
        <v-flex class="item" xs11 md11 lg11>
          <v-text-field
            v-model.trim="registro.nmLocalidade"
            label="Localidade"
            outlined
            clearable
          >
          </v-text-field>
        </v-flex>
      </v-layout>

      <v-layout row justify-center="">
        <v-flex class="item" xs11 md6 lg6>
          <v-text-field
            type="number"
            v-model.number="registro.nrLatitude"
            label="Latitude"
            outlined
            clearable
          >
          </v-text-field>
        </v-flex>
        <v-flex class="item" xs11 md5 lg5>
          <v-text-field
            type="number"
            v-model.number="registro.nrLongitude"
            label="Longitude"
            outlined
            clearable
          >
          </v-text-field>
        </v-flex>
      </v-layout>
    </v-form>
    <v-layout row wrap justify-center v-if="registro.idEstabelecimento > 0">
      <v-flex sm2 xs2 md1>
        <DialogCadastroUEP
          @inserted="selectUnidadeExploracaoInserted"
          :dialog="dialogUnidadeExploracao"
          :idEstabelecimento="registro.idEstabelecimento"
          @openDialog="openDialogUnidadeExploracao"
          @closeDialog="closeDialogUnidadeExploracao"
          @updated="unidadeExploracaoUpdated"
          :rec="atualUEP"
        />
      </v-flex>
      <v-flex sm12 xs12 md10 mt-2>
        <h3>
          <b>Unidades de Exploração Pecuária</b>
        </h3>
      </v-flex>
    </v-layout>
    <v-container
      fluid
      v-if="registro.idEstabelecimento > 0"
      :key="componentKeyUeps"
    >
      <v-data-iterator
        :items="registro.ueps"
        :items-per-page.sync="itemsPerPageUEP"
      >
        <template v-slot:default="props">
          <v-row>
            <v-col
              v-for="item in props.items"
              :key="item.idUnidadeExploracao"
              cols="12"
              sm="12"
              md="6"
              lg="6"
            >
              <v-card hover>
                <v-card-title>
                  <h5>
                    {{ item.dsTipoUnidadeExploracao }}:
                    {{ item.nrUnidadeExploracao }}
                  </h5>
                  <v-spacer />
                  <v-btn
                    id="editUEP"
                    @click="editarUEP(item)"
                    v-if="item.idUnidadeExploracao != 0"
                    text
                    icon
                    small
                    slot="activator"
                    style="margin: 0;"
                  >
                    <v-icon small color="#10303D">fas fa-pen </v-icon>
                  </v-btn>
                  <v-btn
                    id="deleteUEP"
                    @click="removerUEP(item)"
                    v-if="item.idUnidadeExploracao != 0"
                    text
                    icon
                    small
                    slot="activator"
                    style="margin: 0;"
                  >
                    <v-icon small color="#10303D">fas fa-trash-alt </v-icon>
                  </v-btn>
                </v-card-title>
                <v-divider></v-divider>
                <v-list dense class="pb-0">
                  <v-list-item>
                    <v-row class="ma-0 pr-2">
                      <span class="caption">Capacidade:</span>
                      <v-spacer />
                      <span class="caption black--text">
                        {{ item.qtCapacidadeAlojamento }}
                      </span>
                    </v-row>
                  </v-list-item>
                  <v-list-item style="margin-top: -15px;">
                    <v-row class="ma-0" align="center">
                      <span class="caption">Ativa:</span>
                      <v-spacer />
                      <v-switch
                        dense
                        :ripple="false"
                        class="align-start"
                        @change="changeStatusUEP(item)"
                        color="info"
                        v-model="item.stAtivo"
                      />
                    </v-row>
                  </v-list-item>
                  <v-list-item style="margin-top: -30px;">
                    <v-row class="ma-0" align="center">
                      <span class="caption">Possui ambiência:</span>
                      <v-spacer />
                      <v-switch
                        dense
                        :ripple="false"
                        class="align-start"
                        @change="changePossuiAmbiencia(item)"
                        color="info"
                        v-model="item.stPossuiAmbiencia"
                      />
                    </v-row>
                  </v-list-item>
                </v-list>
                <v-expansion-panels flat tile accordion>
                  <v-expansion-panel>
                    <v-expansion-panel-header class="px-4 py-0"
                      >Perfil
                    </v-expansion-panel-header>
                    <v-expansion-panel-content eager>
                      <v-list dense>
                        <v-list-item>
                          <v-list-item-content class="caption">
                            Comedouros:
                          </v-list-item-content>
                          <v-list-item-content class="align-end subtitle-2">
                            <v-list-item-subtitle
                              class="caption black--text font-weight-regular"
                            >
                              <v-tooltip right>
                                <template
                                  v-slot:activator="{
                                    on
                                  }"
                                >
                                  <span v-on="on">
                                    {{
                                      item.tipoComedouros
                                        ? item.tipoComedouros
                                            .map(i => i.nmTipoComedouro)
                                            .join(", ")
                                        : ""
                                    }}
                                  </span>
                                </template>
                                <span>
                                  {{
                                    item.tipoComedouros
                                      ? item.tipoComedouros
                                          .map(i => i.nmTipoComedouro)
                                          .join(", ")
                                      : ""
                                  }}
                                </span>
                              </v-tooltip>
                            </v-list-item-subtitle>
                          </v-list-item-content>
                        </v-list-item>
                        <v-list-item>
                          <v-list-item-content class="caption"
                            >Bebedouros:
                          </v-list-item-content>
                          <v-list-item-content class="align-end subtitle-2">
                            <v-list-item-subtitle
                              class="caption black--text font-weight-regular"
                            >
                              <v-tooltip right>
                                <template
                                  v-slot:activator="{
                                    on
                                  }"
                                >
                                  <span v-on="on">
                                    {{
                                      item.tipoBebedouros
                                        ? item.tipoBebedouros
                                            .map(i => i.nmTipoBebedouro)
                                            .join(", ")
                                        : ""
                                    }}
                                  </span>
                                </template>
                                <span>
                                  {{
                                    item.tipoBebedouros
                                      ? item.tipoBebedouros
                                          .map(i => i.nmTipoBebedouro)
                                          .join(", ")
                                      : ""
                                  }}
                                </span>
                              </v-tooltip>
                            </v-list-item-subtitle>
                          </v-list-item-content>
                        </v-list-item>
                        <v-list-item>
                          <v-list-item-content class="caption"
                            >Pisos:
                          </v-list-item-content>
                          <v-list-item-content class="align-end subtitle-2">
                            <v-list-item-subtitle
                              class="caption black--text font-weight-regular"
                            >
                              <v-tooltip right>
                                <template
                                  v-slot:activator="{
                                    on
                                  }"
                                >
                                  <span v-on="on">
                                    {{
                                      item.tipoPisos
                                        ? item.tipoPisos
                                            .map(i => i.nmTipoPiso)
                                            .join(", ")
                                        : ""
                                    }}
                                  </span>
                                </template>
                                <span>
                                  {{
                                    item.tipoPisos
                                      ? item.tipoPisos
                                          .map(i => i.nmTipoPiso)
                                          .join(", ")
                                      : ""
                                  }}
                                </span>
                              </v-tooltip>
                            </v-list-item-subtitle>
                          </v-list-item-content>
                        </v-list-item>
                        <v-list-item>
                          <v-list-item-content class="caption"
                            >Total de silos:
                          </v-list-item-content>
                          <v-list-item-content
                            class="caption black--text font-weight-regular"
                          >
                            {{ item.silos ? item.silos.length : 0 }}
                          </v-list-item-content>
                        </v-list-item>
                        <v-list-item>
                          <v-list-item-content class="caption"
                            >Capacidade total de silos:
                          </v-list-item-content>
                          <v-list-item-content
                            class="caption black--text font-weight-regular"
                          >
                            {{
                              item.silos && item.silos.length > 0
                                ? item.silos.reduce(
                                    (acc, curr) => acc + curr.qtCapacidadeSilo,
                                    0
                                  )
                                : 0
                            }}
                          </v-list-item-content>
                        </v-list-item>
                      </v-list>
                    </v-expansion-panel-content>
                  </v-expansion-panel>
                </v-expansion-panels>
              </v-card>
            </v-col>
          </v-row>
        </template>
      </v-data-iterator>
    </v-container>
    <v-layout row justify-center v-if="registro.idEstabelecimento > 0">
      <v-flex sm2 xs2 md1>
        <DialogCadastroProdutor
          @inserted="selectProdutorInserted"
          :dialog="dialogProdutor"
          :idEstabelecimento="registro.idEstabelecimento"
          @openDialog="openDialogProdutor"
          @closeDialog="closeDialogProdutor"
          @updated="produtorUpdated"
          :rec="atualProdutor"
        />
      </v-flex>
      <v-flex sm12 xs12 md10 mt-2>
        <h3>
          <b>Produtores</b>
        </h3>
      </v-flex>
    </v-layout>
    <v-container fluid v-if="registro.idEstabelecimento > 0">
      <v-data-iterator
        :items="registro.produtores"
        :items-per-page.sync="itemsPerPageProdutor"
      >
        <template v-slot:default="props">
          <v-row>
            <v-col
              v-for="item in props.items"
              :key="item.idProdutor"
              cols="12"
              sm="12"
              md="6"
              lg="6"
            >
              <v-card hover>
                <v-card-title>
                  <h5>{{ item.nmProdutor }}</h5>
                  <v-spacer />
                  <v-btn
                    id="editProdutor"
                    @click="editarProdutor(item)"
                    v-if="item.idProdutor != 0"
                    text
                    icon
                    small
                    slot="activator"
                    style="margin: 0;"
                  >
                    <v-icon small color="#10303D">fas fa-pen </v-icon>
                  </v-btn>
                  <v-btn
                    id="deleteProdutor"
                    @click="removerProdutor(item)"
                    v-if="item.idProdutor != 0"
                    text
                    icon
                    small
                    slot="activator"
                    style="margin: 0;"
                  >
                    <v-icon small color="#10303D">fas fa-trash-alt </v-icon>
                  </v-btn>
                </v-card-title>
                <v-divider></v-divider>
                <v-list dense>
                  <v-list-item>
                    <v-list-item-content class="caption"
                      >Identificador:
                    </v-list-item-content>
                    <v-list-item-content class="align-end subtitle-2"
                      >{{ item.idProdutor }}
                    </v-list-item-content>
                  </v-list-item>
                  <v-list-item>
                    <v-list-item-content class="caption"
                      >CPF:
                    </v-list-item-content>
                    <v-list-item-content class="align-end subtitle-2"
                      >{{ formatCPF(item.nrDocumento) }}
                    </v-list-item-content>
                  </v-list-item>
                  <v-list-item>
                    <v-list-item-content class="caption"
                      >Celular:
                    </v-list-item-content>
                    <v-list-item-content class="align-end subtitle-2"
                      >{{ item.nrTelefone }}
                    </v-list-item-content>
                  </v-list-item>
                  <v-list-item>
                    <v-list-item-content class="caption"
                      >Possui usuário do Aplicativo:
                    </v-list-item-content>
                    <v-list-item-content class="align-end subtitle-2"
                      >{{ item.idKeycloak ? "Sim" : "Não" }}
                    </v-list-item-content>
                  </v-list-item>
                </v-list>
              </v-card>
            </v-col>
          </v-row>
        </template>
      </v-data-iterator>
    </v-container>
    <v-layout row justify-center v-if="registro.idEstabelecimento > 0">
      <v-flex sm2 xs2 md1>
        <DialogCadastroUsuario
          @inserted="selectUsuarioInserted"
          :dialog="dialogUsuario"
          :idEstabelecimento="registro.idEstabelecimento"
          @openDialog="openDialogUsuario"
          @closeDialog="closeDialogUsuario"
          @updated="usuarioUpdated"
          :rec="atualUsuario"
        />
      </v-flex>
      <v-flex sm12 xs12 md10 mt-2>
        <h3>
          <b>Usuários</b>
        </h3>
      </v-flex>
    </v-layout>
    <v-container fluid v-if="registro.idEstabelecimento > 0">
      <v-data-iterator
        :items="registro.usuarios"
        :items-per-page.sync="itemsPerPageUsuario"
      >
        <template v-slot:default="props">
          <v-row>
            <v-col
              v-for="item in props.items"
              :key="item.idUsuario"
              cols="12"
              sm="12"
              md="6"
              lg="6"
            >
              <v-card hover>
                <v-card-title>
                  <h5>{{ item.nmUsuario }}</h5>
                  <v-spacer />
                  <v-btn
                    id="editUsuario"
                    @click="editarUsuario(item)"
                    v-if="item.idUsuario != 0"
                    text
                    icon
                    small
                    slot="activator"
                    style="margin: 0;"
                  >
                    <v-icon small color="#10303D">fas fa-pen </v-icon>
                  </v-btn>
                  <v-btn
                    id="deleteUsuario"
                    @click="removerUsuario(item)"
                    v-if="item.idUsuario != 0"
                    text
                    icon
                    small
                    slot="activator"
                    style="margin: 0;"
                  >
                    <v-icon small color="#10303D">fas fa-trash-alt </v-icon>
                  </v-btn>
                </v-card-title>
                <v-divider></v-divider>
                <v-list dense>
                  <v-list-item>
                    <v-list-item-content class="caption"
                      >Identificador:
                    </v-list-item-content>
                    <v-list-item-content class="align-end subtitle-2"
                      >{{ item.idUsuario }}
                    </v-list-item-content>
                  </v-list-item>
                  <v-list-item>
                    <v-list-item-content class="caption"
                      >UserName:
                    </v-list-item-content>
                    <v-list-item-content class="align-end subtitle-2"
                      >{{ item.dsUsername }}
                    </v-list-item-content>
                  </v-list-item>
                  <v-list-item>
                    <v-list-item-content class="caption"
                      >Celular:
                    </v-list-item-content>
                    <v-list-item-content class="align-end subtitle-2"
                      >{{ item.nrTelefone }}
                    </v-list-item-content>
                  </v-list-item>
                  <v-list-item>
                    <v-list-item-content class="caption"
                      >E-mail:
                    </v-list-item-content>
                    <v-list-item-content class="align-end subtitle-2"
                      >{{ item.dsEmail }}
                    </v-list-item-content>
                  </v-list-item>
                </v-list>
              </v-card>
            </v-col>
          </v-row>
        </template>
      </v-data-iterator>
    </v-container>
    <v-layout pa-2 pr-8 pl-8>
      <v-flex>
        <AppMainActionsButtonsForm
          @save="saveRegistro"
          @return="voltar"
          :canDelete="false"
        />
      </v-flex>
    </v-layout>
  </AppMainFormCard>
</template>

<script>
import { campoObrigatorio, campoSelectObrigatorio } from "@/filters/rules";
import { formatCPF } from "@/filters/utils";
import {
  TituloShouldNavigate,
  MensagemShouldNavigate,
  MensagemSuccessSave
} from "@/resourceMessageFile.js";

import AppMainFormCard from "@/components/layout/AppMainFormCard.vue";
import AppMainActionsButtonsForm from "@/components/layout/AppMainActionsButtonsForm.vue";
import DialogCadastroUEP from "@/components/dialogs/DialogCadastroUEP.vue";
import DialogCadastroProdutor from "@/components/dialogs/DialogCadastroProdutor.vue";
import DialogCadastroUsuario from "@/components/dialogs/DialogCadastroUsuario.vue";
import { mask } from "vue-the-mask";

export default {
  name: "Estabelecimento",
  components: {
    AppMainFormCard,
    AppMainActionsButtonsForm,
    DialogCadastroUEP,
    DialogCadastroProdutor,
    DialogCadastroUsuario
  },
  directives: {
    mask
  },
  data() {
    return {
      isFormValid: false,
      isEditing: false,
      isModified: false,
      registro: {},
      registroBanco: {},
      filteredCities: [],
      isLoading: false,
      dialogProdutor: false,
      dialogUnidadeExploracao: false,
      dialogUsuario: false,
      tiposStatus: [
        {
          csAtivo: "T",
          dsStatus: "Ativo"
        },
        {
          csAtivo: "F",
          dsStatus: "Inativo"
        }
      ],
      atualProdutor: {},
      atualUEP: {},
      atualUsuario: {},
      maskCodigoOficial: "##-#########",
      itemsPerPageUEP: 6,
      itemsPerPageProdutor: 6,
      itemsPerPageUsuario: 6,
      componentKeyUeps: 0
    };
  },
  computed: {
    ufs() {
      return this.$store.state.ufs;
    },
    municipios() {
      return this.$store.state.municipios;
    },
    urlAPIEstabelecimento() {
      return this.$store.state.urlAPIEstabelecimento;
    },
    tituloTela: {
      get() {
        if (this.isEditing)
          return "Estabelecimento: " + this.registro.idEstabelecimento;

        return "Inserindo novo Estabelecimento";
      }
    },
    tiposUnidadesExploracao() {
      return this.$store.state.tiposUnidadesExploracao;
    }
  },
  methods: {
    campoObrigatorio,
    campoSelectObrigatorio,
    formatCPF,
    toEstabelecimentoView(entry) {
      let dsTipoUnidadeExploracao = this.tiposUnidadesExploracao.find(
        i => i.csTipoUnidadeExploracao === entry.csTipoUnidadeExploracao
      ).dsTipoUnidadeExploracao;
      return { ...entry, dsTipoUnidadeExploracao };
    },
    changeViewState(status, value) {
      if (status == "isInserting") {
        this.isLoading = true;
        if (this.$refs.form != undefined) {
          this.$refs.form.reset();
        }
        this.carregarRegistrosLimpos();
        this.isLoading = false;
        this.isEditing = false;
        this.isModified = false;
      } else if (status == "isEditing") {
        this.isLoading = true;
        this.getRegistro(value);
        this.isEditing = true;
      } else if (status == "isError") {
        this.$store.commit("setSnack", { type: "error", msg: value });
        this.isLoading = false;
      } else if (status == "endLoading") {
        this.isLoading = false;
      } else if (status == "isLoading") {
        this.isLoading = true;
      }
    },
    initViewFromRoute(route) {
      this.$store.dispatch("actLoadUFs");
      if (route.params.id) {
        this.changeViewState("isEditing", route.params.id);
      } else {
        this.changeViewState("isInserting", null);
      }
    },
    getRegistro(id) {
      this.$axios
        .get(this.urlAPIEstabelecimento + "estabelecimento/" + id)
        .then(response => {
          var rec = response.data;
          this.registro = Object.assign({}, rec);
          this.registroBanco = Object.assign({}, rec);
          this.changeViewState("endLoading");
          this.getListUeps(id);
          this.getListProdutores(id);
          this.getListUsuarios(id);
        })
        .catch(error => {
          this.changeViewState("isError", error);
          this.$router.push({ path: "/estabelecimento" });
        });
    },
    getListSilos() {
      var context = this;
      context.registro.ueps.forEach(function(uep) {
        context.$axios
          .get(
            context.urlAPIEstabelecimento +
              "silo/?cdUep=" +
              uep.idUnidadeExploracao
          )
          .then(response => {
            var records = response.data;
            console.log(records);
            if (records.length > 0) {
              uep.silos = records;
            }
            context.forceRerenderUeps();
          })
          .catch(error => {
            this.changeViewState("isError", error);
          });
      });
    },
    getListUeps(idEstabelecimento) {
      var context = this;
      this.$axios
        .get(
          this.urlAPIEstabelecimento +
            "unidadeExploracao/?cdEstabelecimento=" +
            idEstabelecimento
        )
        .then(response => {
          var records = response.data
            ? response.data.map(this.toEstabelecimentoView)
            : [];
          console.log(records);
          context.registro.ueps = records;
          context.registro = Object.assign({}, context.registro);
          context.registroBanco = Object.assign({}, context.registro);
          context.getListSilos();
        })
        .catch(error => {
          this.changeViewState("isError", error);
        });
    },
    getListProdutores(idEstabelecimento) {
      var context = this;
      this.$axios
        .get(
          this.urlAPIEstabelecimento +
            "produtor/?cdEstabelecimento=" +
            idEstabelecimento
        )
        .then(response => {
          context.registro.produtores = response.data;
          context.registro = Object.assign({}, context.registro);
          context.registroBanco = Object.assign({}, context.registro);
        })
        .catch(error => {
          this.changeViewState("isError", error);
        });
    },
    getListUsuarios(idEstabelecimento) {
      var context = this;
      this.$axios
        .get(
          this.urlAPIEstabelecimento +
            "usuario/?cdEstabelecimento=" +
            idEstabelecimento
        )
        .then(response => {
          context.registro.usuarios = response.data;
          context.registro = Object.assign({}, context.registro);
          context.registroBanco = Object.assign({}, context.registro);
        })
        .catch(error => {
          this.changeViewState("isError", error);
        });
    },
    saveRegistro() {
      if (this.$refs.form.validate()) {
        if (this.isEditing) {
          this.updateRegistro();
        } else {
          this.insertRegistro();
        }
      }
    },
    completaCodigoOficialDozeDigitos() {
      if (this.registro.nrCodigoOficial.length < 12) {
        var prefixo = this.registro.nrCodigoOficial.substring(0, 3);
        var value = this.registro.nrCodigoOficial.substring(
          3,
          this.registro.nrCodigoOficial.length
        );

        const resto = 9 - String(value).length;
        var valorAjustado = "0".repeat(resto > 0 ? resto : "0") + value;

        this.registro.nrCodigoOficial = prefixo + valorAjustado;
      }
    },
    insertRegistro() {
      this.changeViewState("isLoading");
      this.registro.cdPais = 1;
      this.registro.nrLatitude =
        this.registro.nrLatitude == "" ? null : this.registro.nrLatitude;
      if (this.registro.nrLatitude != null) {
        var floatNrLatitude = this.registro.nrLatitude
          .toString()
          .replace(",", ".");
        this.registro.nrLatitude = parseFloat(floatNrLatitude).toFixed(7);
      }
      this.registro.nrLongitude =
        this.registro.nrLongitude == "" ? null : this.registro.nrLongitude;
      if (this.registro.nrLongitude != null) {
        var floatNrLongitude = this.registro.nrLongitude
          .toString()
          .replace(",", ".");
        this.registro.nrLongitude = parseFloat(floatNrLongitude).toFixed(7);
      }
      this.$axios
        .post(this.urlAPIEstabelecimento + "estabelecimento/", this.registro)
        .then(response => {
          this.$router.replace({
            name: "estabelecimento",
            params: { id: response.data.idEstabelecimento }
          });
          this.$store.commit("setSnack", {
            type: "success",
            msg: MensagemSuccessSave
          });
          this.changeViewState("endLoading");
          this.$store.dispatch("actLoadEstabelecimentos");
        })
        .catch(error => {
          this.changeViewState("isError", error);
        });
    },
    updateRegistro() {
      this.changeViewState("isLoading");
      if (this.registro.nrLatitude != null) {
        var floatNrLatitude = this.registro.nrLatitude
          .toString()
          .replace(",", ".");
        this.registro.nrLatitude = parseFloat(floatNrLatitude).toFixed(7);
      }
      if (this.registro.nrLongitude != null) {
        var floatNrLongitude = this.registro.nrLongitude
          .toString()
          .replace(",", ".");
        this.registro.nrLongitude = parseFloat(floatNrLongitude).toFixed(7);
      }
      this.$axios
        .put(
          this.urlAPIEstabelecimento +
            "estabelecimento/" +
            this.registro.idEstabelecimento,
          this.registro
        )
        .then(() => {
          this.$store.commit("setSnack", {
            type: "success",
            msg: MensagemSuccessSave
          });
          this.initViewFromRoute(this.$route);
          this.$store.dispatch("actLoadEstabelecimentos");
        })
        .catch(error => {
          var context = this;
          for (var erro in error.response.data.errors) {
            context.changeViewState(
              "isError",
              error.response.data.errors[erro].toString()
            );
          }
        });
    },
    novoRegistro() {
      this.$router.push({ path: "/estabelecimento" });
    },
    carregarRegistrosLimpos() {
      this.registro = {
        idEstabelecimento: 0,
        nrCodigoOficial: "",
        nmEstabelecimento: "",
        cdPais: 1,
        cdUf: 0,
        cdMunicipio: 0,
        nmLocalidade: "",
        nrLatitude: "",
        nrLongitude: "",
        ueps: [],
        produtores: [],
        usuarios: []
      };
      this.registroBanco = {
        idEstabelecimento: 0,
        nrCodigoOficial: "",
        nmEstabelecimento: "",
        cdPais: 1,
        cdUf: 0,
        cdMunicipio: 0,
        nmLocalidade: "",
        nrLatitude: "",
        nrLongitude: "",
        ueps: [],
        produtores: [],
        usuarios: []
      };
    },
    beforeDeleteRegistro() {
      this.$root
        .$confirm(
          "Deseja Excluir?",
          "O registro será excluído permanentemente.",
          { color: "red", width: 400 }
        )
        .then(confirm => {
          if (confirm) this.deleteRegistro();
        });
    },
    deleteRegistro() {
      this.changeViewState("isLoading");
      this.$axios
        .delete(
          this.urlAPIEstabelecimento +
            "estabelecimento/" +
            this.registro.idEstabelecimento
        )
        .then(() => {
          this.$router.go(-1);
          this.changeViewState("endLoading");
          this.$store.dispatch("actLoadEstabelecimentos");
        })
        .catch(error => {
          this.changeViewState("isError", error);
        });
    },
    goSearch() {
      this.$router.push({ path: "/estabelecimentoSearch" });
    },
    shouldNavigate(to, from, next) {
      if (
        JSON.stringify(this.registro) !== JSON.stringify(this.registroBanco) &&
        !this.isLoading
      ) {
        this.$root
          .$confirm(TituloShouldNavigate, MensagemShouldNavigate, {
            color: "red",
            width: 400
          })
          .then(confirm => {
            next(confirm);
            return confirm;
          });
      } else {
        next();
        return true;
      }
    },
    selectUnidadeExploracaoInserted(unidadeExploracao) {
      unidadeExploracao.dsTipoUnidadeExploracao = this.tiposUnidadesExploracao.find(
        i =>
          i.csTipoUnidadeExploracao ===
          unidadeExploracao.csTipoUnidadeExploracao
      ).dsTipoUnidadeExploracao;
      this.registro.ueps.push(unidadeExploracao);
      this.registro = Object.assign({}, this.registro);
      this.registroBanco = Object.assign({}, this.registro);
      this.$store.dispatch("actLoadEstabelecimentos");
    },
    changeStatusUEP(unidadeExploracao) {
      this.changeViewState("isLoading");
      this.$axios
        .put(
          this.urlAPIEstabelecimento +
            "unidadeExploracao/" +
            unidadeExploracao.idUnidadeExploracao,
          unidadeExploracao
        )
        .then(() => {
          this.initViewFromRoute(this.$route);
          this.$store.dispatch("actLoadEstabelecimentos");
        })
        .catch(error => {
          var uep = this.registro.ueps.find(
            i => i.idUnidadeExploracao == unidadeExploracao.idUnidadeExploracao
          );
          uep.stAtivo = !unidadeExploracao.stAtivo;
          this.$store.commit("setSnack", {
            type: "error",
            msg: error
          });
        })
        .finally(() => {
          this.changeViewState("endLoading");
        });
    },
    changePossuiAmbiencia(unidadeExploracao) {
      this.changeViewState("isLoading");
      this.$axios
        .put(
          this.urlAPIEstabelecimento +
            "unidadeExploracao/" +
            unidadeExploracao.idUnidadeExploracao,
          unidadeExploracao
        )
        .then(() => {
          this.initViewFromRoute(this.$route);
          this.$store.dispatch("actLoadEstabelecimentos");
        })
        .catch(error => {
          var uep = this.registro.ueps.find(
            i => i.idUnidadeExploracao == unidadeExploracao.idUnidadeExploracao
          );
          uep.stPossuiAmbiencia = !unidadeExploracao.stPossuiAmbiencia;
          this.$store.commit("setSnack", {
            type: "error",
            msg: error
          });
        })
        .finally(() => {
          this.changeViewState("endLoading");
        });
    },
    removerUEP(uep) {
      this.$root
        .$confirm(
          "Deseja Excluir Unidade de Exploração?",
          "A Unidade de Exploração será excluída permanentemente.",
          {
            color: "red",
            width: 470
          }
        )
        .then(confirm => {
          if (confirm) {
            this.changeViewState("isLoading");
            this.$axios
              .delete(
                this.urlAPIEstabelecimento +
                  "unidadeExploracao/" +
                  uep.idUnidadeExploracao
              )
              .then(() => {
                this.initViewFromRoute(this.$route);
                this.$store.dispatch("actLoadEstabelecimentos");
              })
              .catch(error => {
                this.changeViewState("isError", error);
              });
          }
        });
    },
    editarUEP(uep) {
      this.atualUEP = uep;
      this.dialogUnidadeExploracao = true;
    },
    closeDialogUnidadeExploracao() {
      this.atualUEP = {};
      this.dialogUnidadeExploracao = false;
    },
    openDialogUnidadeExploracao() {
      this.dialogUnidadeExploracao = true;
    },
    unidadeExploracaoUpdated() {
      this.initViewFromRoute(this.$route);
    },
    selectProdutorInserted(produtor) {
      this.registro.produtores.push(produtor);
      this.registro = Object.assign({}, this.registro);
      this.registroBanco = Object.assign({}, this.registro);
      this.$store.dispatch("actLoadEstabelecimentos");
    },
    removerProdutor(produtor) {
      this.$root
        .$confirm(
          "Deseja Excluir Produtor?",
          "O Produtor será excluído permanentemente.",
          {
            color: "red",
            width: 400
          }
        )
        .then(confirm => {
          if (confirm) {
            this.changeViewState("isLoading");
            this.$axios
              .delete(
                this.urlAPIEstabelecimento + "produtor/" + produtor.idProdutor
              )
              .then(() => {
                this.initViewFromRoute(this.$route);
                this.$store.dispatch("actLoadEstabelecimentos");
              })
              .catch(error => {
                this.changeViewState("isError", error);
              });
          }
        });
    },
    editarProdutor(registro) {
      this.atualProdutor = registro;
      this.dialogProdutor = true;
    },
    closeDialogProdutor() {
      this.atualProdutor = {};
      this.dialogProdutor = false;
    },
    openDialogProdutor() {
      this.dialogProdutor = true;
    },
    produtorUpdated() {
      this.initViewFromRoute(this.$route);
    },
    selectUsuarioInserted(usuario) {
      this.registro.usuarios.push(usuario);
      this.registro = Object.assign({}, this.registro);
      this.registroBanco = Object.assign({}, this.registro);
      this.$store.dispatch("actLoadEstabelecimentos");
    },
    removerUsuario(usuario) {
      this.$root
        .$confirm(
          "Deseja Excluir Usuário?",
          "O Usuário será excluído permanentemente.",
          {
            color: "red",
            width: 400
          }
        )
        .then(confirm => {
          if (confirm) {
            this.changeViewState("isLoading");
            this.$axios
              .delete(
                this.urlAPIEstabelecimento + "usuario/" + usuario.idUsuario
              )
              .then(() => {
                this.initViewFromRoute(this.$route);
                this.$store.dispatch("actLoadEstabelecimentos");
              })
              .catch(error => {
                this.changeViewState("isError", error);
              });
          }
        });
    },
    editarUsuario(registro) {
      this.atualUsuario = registro;
      this.dialogUsuario = true;
    },
    closeDialogUsuario() {
      this.atualUsuario = {};
      this.dialogUsuario = false;
    },
    openDialogUsuario() {
      this.dialogUsuario = true;
    },
    usuarioUpdated() {
      this.initViewFromRoute(this.$route);
    },
    voltar() {
      this.$router.go(-1);
    },
    forceRerenderUeps() {
      this.componentKeyUeps += 1;
    }
  },
  watch: {
    $route(to) {
      this.initViewFromRoute(to);
    },
    "registro.cdUf"(value) {
      this.filteredCities = [];
      if (value != undefined) {
        if (
          !this.municipios.some(function(elem) {
            return elem.cdUf == value;
          }) &&
          value != 0
        ) {
          this.$store.dispatch("actLoadMunicipiosByUf", value);
        } else {
          this.filteredCities = this.municipios.filter(x => x.cdUf == value);
        }
      }
      this.cdMunicipio = 0;
    },
    municipios(value) {
      this.filteredCities = value.filter(x => x.cdUf == this.registro.cdUf);
    }
  },
  mounted() {
    this.initViewFromRoute(this.$route);
  },
  beforeRouteUpdate(to, from, next) {
    this.shouldNavigate(to, from, next);
  },
  beforeRouteLeave(to, from, next) {
    this.shouldNavigate(to, from, next);
  }
};
</script>

<style scoped>
.item {
  margin: 1px;
}

.marginTitle {
  margin: 15px;
}

.headerCard {
  color: white;
  background: #04222d;
  padding: 10px;
}

::v-deep .v-expansion-panel-content__wrap {
  padding-left: 16px !important;
  padding-right: 16px !important;
}

.v-expansion-panel-header {
  min-height: 42px !important;
}
</style>
